import { render, staticRenderFns } from "./ModifyDone.vue?vue&type=template&id=c56f3c12&scoped=true"
import script from "./ModifyDone.vue?vue&type=script&lang=js"
export * from "./ModifyDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f3c12",
  null
  
)

export default component.exports